<div class="flex shrink-0 items-center gap-2">
  <app-tree-search
    class="block flex-1"
    [placeholder]="searchPlaceholder"
    (search)="onSearch($event)"
    (reset)="onReset()"
  ></app-tree-search>
  <!-- Optional action beside the search. Projected so this stays a generic tree view - the affiliate
       picker puts its "Show all" toggle here without the component knowing what affiliation is. -->
  <ng-content select="[treeSearchAction]"></ng-content>
</div>
<ejs-treeview
  class="tl-org-tree min-h-0 flex-1 overflow-y-auto"
  #tree
  [fields]="field"
  [showCheckBox]="allowSelection"
  [allowMultiSelection]="false"
  (nodeChecked)="onChecked($event)"
  (nodeSelected)="onNodeSelected($event)"
  (nodeSelecting)="onNodeSelected($event)"
  (dataBound)="onDataBound($event)"
  (nodeSelected)="onChecked($event)"
  (nodeChecking)="onNodeChecking($event)"
  (drawNode)="onDrawNode($event)"
  (nodeClicked)="onNodeSelect($event)"
  [autoCheck]="false"
>
  <ng-template #nodeTemplate let-data>
    <ng-container *ngIf="data.isMatch; else normal">
      <span
        [appHighlightSearch]="data.name"
        [searchTerm]="searchText"
        [highlightClass]="'highlighted-text'"
      ></span>
    </ng-container>
    <ng-template #normal>
      {{ data.name }}
    </ng-template>
  </ng-template>
</ejs-treeview>
